module.exports = __webpack_public_path__ + "static/Vabysmo_Treatment_G-670997d8c989f96d77ac4d8ba1e68a78.jpg";